import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import ReactPaginate from 'react-paginate'
import Select from 'react-select';
import Moment, { defaultFormat } from 'moment';
import { ControlLabel, Form, FormGroup, FormControl, Row, Col, Button, Pagination } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import HrStore from '../../../stores/HrStore'

const localStorageKey = 'kkc.employeeAbsence'
class ReportEmployeeAbsence extends Component {

  constructor(...args) {
    super(...args)

    const yTh = parseInt(Moment().format('YYYY')) + 543
    const curMonth = parseInt(Moment().format('MM'))
    const curDay = parseInt(Moment().format('DD'))
    const all_day = Moment().daysInMonth()

    const optionsDay = []
    const optionsYear = []

    for (var i = yTh; i >= 2557; i--) {
      optionsYear.push({
        value: i,
        label: i
      });
    }

    for (var i=0;i<=all_day;i++) {
      if (i == 0) {
        var label = "ทั้งเดือน"
      } else {
        var label = i
      }
      optionsDay.push({
        value: i,
        label: label
      })
    }
    
    const optionsMonth = [
      { value: 0, label: 'ทั้งปี' },
      { value: 1, label: 'มกราคม' },
      { value: 2, label: 'กุมภาพันธ์' },
      { value: 3, label: 'มีนาคม' },
      { value: 4, label: 'เมษายน' },
      { value: 5, label: 'พฤษภาคม' },
      { value: 6, label: 'มิถุนายน' },
      { value: 7, label: 'กรกฎาคม' },
      { value: 8, label: 'สิงหาคม' },
      { value: 9, label: 'กันยายน' },
      { value: 10, label: 'ตุลาคม' },
      { value: 11, label: 'พฤศจิกายน' },
      { value: 12, label: 'ธันวาคม' }
    ];

    this.state = {
      loading: false, 
      emList: [],
      sort: JSON.parse(localStorage.getItem(localStorageKey)) || {sortStatus:'',sortStatus2:''},
      optionsYear: optionsYear, 
      optionsMonth: optionsMonth,
      defaultYear: yTh,
      defaultMonth: curMonth, 
    }

    this.loadEmployeeAllabsence(yTh-543,curMonth)
  }

  onYearChange(e) {
    let {defaultYear,defaultMonth} = this.state
    defaultYear = e.value
    this.setState({defaultYear:defaultYear})
    this.loadEmployeeAllabsence(e.value-543,defaultMonth)
  }

  onMonthChange(e) {
    let {defaultYear,defaultMonth} = this.state
    defaultMonth = e.value
    this.setState({defaultMonth:defaultMonth})
    this.loadEmployeeAllabsence(defaultYear-543,e.value)
  }

  loadEmployeeAllabsence(year,month) {
    let that = this
    let {sort} = this.state
    this.setState({loading:true})
    HrStore.loadEmployeeAllabsence(year,month,function (result) {
      let data = result.data
      if (sort.sortStatus===''&&sort.sortStatus2==='') {  
        data = result.data
      } else {
        if (sort.sortStatus!=='') {
          if (sort.sortStatus===''||sort.sortStatus==='desc') {
            data.sort(function(a, b) {
	            if(a[1] < b[1]) return -1;
	            if(a[1] > b[1]) return 1;
	            return 0;
	        })
	        data.reverse(function(a, b) {
	            if(a[1] < b[1]) return -1;
	            if(a[1] > b[1]) return 1;
	            return 0;
	        })
          } else if (sort.sortStatus==='asc') {
            data.sort(function(a, b) {
	            if(a[1] < b[1]) return -1;
	            if(a[1] > b[1]) return 1;
	            return 0;
	        })
          }
        } else if (sort.sortStatus2!=='') {
          if (sort.sortStatus2===''||sort.sortStatus2==='desc') {
          	data.sort()
            data.reverse()
          } else if (sort.sortStatus2==='asc') {
            data.sort()
          }
        }
      } 

      that.setState({ loading: false, emList: data })
    })
  }

  onRowClick(emId) {
    if (process.env.NODE_ENV == "development") {
      alert('click employee ' + emId)
    } else {
      
    }
  }

  renderToolbar() {
    return (
      	<Form inline>
            <FormGroup>
              <Select
                clearable={false}
                name="form-field-name"
                value={ this.state.defaultYear }
                options={this.state.optionsYear}
                style={{ width: "80px" }}
                onChange={ this.onYearChange.bind(this) }
              />
            </FormGroup>  
            {' '}
            <FormGroup>
              <Select
                clearable={false}
                name="form-field-name"
                value={ this.state.defaultMonth }
                options={this.state.optionsMonth}
                style={{ width: "110px" }}
                onChange={ this.onMonthChange.bind(this) }
              />
            </FormGroup>
        </Form>    
    )
  }

  renderRowData() {
    let { emList } = this.state
    if (emList===undefined||emList.length===0) {
    	return(<tr><td colSpan={7}>ไม่พบข้อมูล</td></tr>)
    }
    return emList.map((item, index) => (
      <tr key={index}>
        <td>{item[1]}</td>
        <td>{item[2]}</td>
        <td>{item[3]}</td>
        <td>{item[4]}</td>
        <td>{item[5]}</td>
        <td>{item[6]}</td>
        <td>{item[7]}</td>
      </tr>
    ))
  }

  renderTable() {
    let {sort} = this.state
    return (
      <Row >
        <Col md={12}>
          <table className='table table-responsive table-hover table-bordered-solid'>
            <thead>
              <tr>
                <th onClick={this.onSortClick.bind(this,'name')}>ชื่อนามสกุล&nbsp;<FontAwesome className={'pull-right'} name={(sort.sortStatus===''?'sort':sort.sortStatus==='asc'?'sort-asc':sort.sortStatus==='desc'?'sort-desc':'sort')} /></th>
                <th onClick={this.onSortClick.bind(this,'absence_date')}>ลาวันที่&nbsp;<FontAwesome className={'pull-right'} name={(sort.sortStatus2===''?'sort':sort.sortStatus2==='asc'?'sort-asc':sort.sortStatus2==='desc'?'sort-desc':'sort')} /></th>
                <th>ถึงวันที่</th>
                <th>ระยะเวลา</th>
                <th>เหตุผล</th>
                <th>หมายเหตุ</th>
                <th>บันทึกโดย</th>
              </tr>
            </thead>
            <tbody>
              {this.renderRowData()}
            </tbody>
            <tfoot>
              <tr >
                <th onClick={this.onSortClick.bind(this,'name')}>ชื่อนามสกุล&nbsp;<FontAwesome className={'pull-right'} name={(sort.sortStatus===''?'sort':sort.sortStatus==='asc'?'sort-asc':sort.sortStatus==='desc'?'sort-desc':'sort')} /></th>
                <th onClick={this.onSortClick.bind(this,'absence_date')}>ลาวันที่&nbsp;<FontAwesome className={'pull-right'} name={(sort.sortStatus2===''?'sort':sort.sortStatus2==='asc'?'sort-asc':sort.sortStatus2==='desc'?'sort-desc':'sort')} /></th>
                <th>ถึงวันที่</th>
                <th>ระยะเวลา</th>
                <th>เหตุผล</th>
                <th>หมายเหตุ</th>
                <th>บันทึกโดย</th>
              </tr>
            </tfoot>
          </table>
        </Col>
      </Row>

    )
  }

  onSortClick(key,e) {
    let {emList,sort} = this.state
    if (emList!==undefined&&emList.length>1) {
      if (key==='name') { 
        if (sort.sortStatus===''||sort.sortStatus==='desc') {
          sort.sortStatus = 'asc'
          emList.sort(function(a, b) {
            if(a[1] < b[1]) return -1;
            if(a[1] > b[1]) return 1;
            return 0;
          })
        } else if (sort.sortStatus==='asc') {
          sort.sortStatus = 'desc'
          emList.reverse(function(a, b) {
            if(a[1] < b[1]) return -1;
            if(a[1] > b[1]) return 1;
            return 0;
          })
        }
        sort.sortStatus2 = ''
      } else if (key==='absence_date') { 
        if (sort.sortStatus2===''||sort.sortStatus2==='desc') {
          sort.sortStatus2 = 'asc'
          emList.sort()
        } else if (sort.sortStatus2==='asc') {
          sort.sortStatus2 = 'desc'
          emList.reverse()
        }
        sort.sortStatus = ''
      }
      let reportEmConfig = {sortStatus:sort.sortStatus,sortStatus2:sort.sortStatus2}
      localStorage.setItem(localStorageKey, JSON.stringify(reportEmConfig))
      this.setState({emList:emList,sort:sort})
    }  
  }

  render() {
    let title = 'ตารางประวัติลางาน'
    return (
      <Box loading={this.state.loading}>
        <Box.Header border={true}>
          <Box.Title><FontAwesome name='history' className='color-blue' />{' '}{title}</Box.Title>
        </Box.Header>
        <Box.Body>
          {this.renderToolbar()}
          <br/>
          {this.renderTable()}
        </Box.Body>
      </Box>
    )
  }
}


export default ReportEmployeeAbsence;



// WEBPACK FOOTER //
// ./src/view/hr/report/ReportEmployeeAbsence.js